// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9686) return "static/chunks/984551f7-5e47ed53ecbb1268.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1355":"537129444b621e64","4061":"1dd718fca5066005"}[chunkId] + ".js";
};